import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BreadcrumbsService } from '@shared/services/breadcrumbs/breadcrumbs.service';
import { AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [RouterLink, MatIcon, AsyncPipe]
})
export class BreadcrumbComponent implements OnInit {

  constructor(
    public breadcrumbsService: BreadcrumbsService
  ) {

  }

  ngOnInit(): void {
  }

}
